/* jshint esversion: 6 */
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default class ScrollAnchorsStickybar {

    constructor(node, id, wrapper) {
        this.node = node;
        this.id = id;

        this.titles = Array.from(document.querySelectorAll('[data-scroll-title]'));
        this.areas = Array.from(document.querySelectorAll('[data-scroll-area]')).filter(x => {
            const relativeAreas = [];
            this.titles.forEach(y => {
                if (x.getAttribute('data-scroll-area') === y.getAttribute('data-scroll-title')) {
                    relativeAreas.push(x);
                }
            });
            return relativeAreas;
        });
        this.wrapper = wrapper;
        this.offset = parseFloat(this.node.getAttribute('data-scroll-anchors'));
        this.scrollOffset = parseFloat(this.node.getAttribute('data-scroll-offset-onscroll'))
        this.goToAnchor = this.goToAnchor.bind(this);
        this.onWrapperScroll = this.onWrapperScroll.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.addListeners();
    }

    addListeners() {
        this.titles.forEach(title => {
            title.addEventListener('click', this.goToAnchor);
        });
        this.wrapper.addEventListener('scroll', this.onWrapperScroll);
    }

    removeListeners() {
        this.destroyed = true;
        this.titles.forEach(title => {
            title.removeEventListener('click', this.goToAnchor);
        });
        if (this.wrapper !== window) {
            this.wrapper.removeEventListener('scroll', this.onWrapperScroll);
        }
    }

    goToAnchor(e) {
        this.areas.forEach(area => {
            if (area.getAttribute('data-scroll-area') === e.target.getAttribute('data-scroll-title')) {
                window.scrollTo(0, this.getOffset(area) +  this.scrollOffset);
                setTimeout(() => {
                    const areaIndex = this.areas.indexOf(area);
                    this.titles.forEach((title, i) => {
                        if (i === areaIndex) {
                            title.classList.add('active');
                        } else {
                            title.classList.remove('active');
                        }
                    }); 
                }, 100) 
            }
        });
    }

    onWrapperScroll(e) {
        const area = this.areas.find((area, i) => {
            const top = area.getBoundingClientRect().top;
            const bottom = i < this.areas.length - 1 ? this.areas[i + 1].getBoundingClientRect().top : Number.POSITIVE_INFINITY;
            if (top < this.offset && bottom > this.offset) {
                return area;
            }
        });
        if (this.area_ !== area) {
            this.area_ = area;
            const areaIndex = this.areas.indexOf(area);
            this.titles.forEach((title, i) => {
                if (i === areaIndex) {
                    title.classList.add('active');
                } else {
                    title.classList.remove('active');
                }
            });
        }
    }

    onScroll(e) {
        if (!this.destroyed) {
            this.onWrapperScroll(e);
        }
    }

    getOffset(area) {
        console.log(area.offsetTop, this.offset)
        return area.offsetTop - this.offset;
    }

    destroy() {
        this.removeListeners();
    }

    static destroyAll() {
        ScrollAnchors.items.forEach(node => {
            node.destroy();
        });
    }

    static init(node) {
        const context = node ? node : document;
        ScrollAnchorsStickybar.items = Array.from(context.querySelectorAll('[data-scroll-anchors]')).map((node, id) => new ScrollAnchorsStickybar(node, id, window));
    }

    static onScroll(e) {
        ScrollAnchorsStickybar.items.forEach(node => {
            node.onScroll(e);
        });
    }

}

ScrollAnchorsStickybar.items = [];